
const S4_home = () => {
    return (
        <div className="S4_home">
            <div className="container">
                <div className="intro_S4">
                    <h3>Why Choose Us?</h3>
                    <div className="line"><span></span></div>
                    </div>

                <div className="row">

                    <div className="col-lg-3 col-md-6 ">
                        <div className="hov">
                        <div className="num">01</div>
                        <div className="box">
                            <h4>Huge Collection</h4>
                            <p>A collection of 5,000 unique NEOHs built to go beyond the digital space that will unlock numerous benefits for our community.</p>
                        </div>
                        </div>
                    </div>
                
                    <div className="col-lg-3 col-md-6 act">
                        <div className="hov">
                        <div className="num">02</div>
                        <div className="box">
                            <h4>High Quality</h4>
                            <p>The NEOH collection includes dozens of rare heads, costumes, and colorways of the artist's palette. They are drawn with great care.</p>
                        </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6 ">
                        <div className="hov">
                        <div className="num">03</div>
                        <div className="box">
                            <h4>Top Resource</h4>
                            <p>Tasty design resources made with care for each pixel. Tokens, NFTs, metaverse and game resources. Access additional drops.</p>
                        </div>
                        </div>
                    </div>

                    <div className="col-lg-3 col-md-6 act">
                         <div className="hov">
                        <div className="num">04</div>
                        <div className="box">
                            <h4>Big Community</h4>
                            <p>Be part of a community of neoh owners and create user generated items. Rent, advertise, lounch stores, create items.</p>
                        </div>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    )
}

export default S4_home;